import _ from "lodash";
import {
  TOUR_PRICE_INFO_LOAD_STATE,
  TOUR_PRICE_INFO_SAVE,
  TOUR_PRICE_INFO_SEARCH_SESSION_INFO_SAVE,
  TOUR_SEARCH_DATA_SAVE,
} from "../search/types";
import { BOOKING_INFO_LOAD_STATE } from "../book/types";
import { gotoExternallyHostedPayment } from "../book";
import { fetchAddOnPrice, storeSearchSessionMetadata } from "../../api";
import { toast } from "react-toastify";
import { v4 } from "uuid";
import { useSourceEntity } from "../../hooks";

export const clearStorage = () => {
  window.localStorage.removeItem("addon_search");
};

export const saveToStorage = (data) => {
  window.localStorage.setItem("addon_search", JSON.stringify(data));
};

export function loadTourPriceInfo(data) {
  return { type: TOUR_PRICE_INFO_LOAD_STATE, data };
}

export const loadFromStorage =
  ({ history }) =>
  async (dispatch, getState) => {
    const data = window.localStorage.getItem("addon_search");

    if (typeof data !== "undefined" && data) {
      const json_data = JSON.parse(data);

      if (!json_data.TourPriceInfo) {
        history.push("/404/");
        return;
      }

      if (_.get(json_data, "BookingInformation")) {
        await dispatch({
          type: BOOKING_INFO_LOAD_STATE,
          data: json_data.BookingInformation,
        });
      }

      await dispatch(loadTourPriceInfo(json_data.TourPriceInfo));

      dispatch(gotoExternallyHostedPayment());

      const reference = _.get(getState(), "TourPriceInfo.price_info.reference");
      history.push(`/tour/MI_${reference}`);
    } else {
      history.push("/404/");
    }
  };

export const savePriceInfo = (price_info) => {
  return { type: TOUR_PRICE_INFO_SAVE, price_info };
};

export const savePriceInfoSearchSessionInfo = (search_session_info) => {
  return {
    type: TOUR_PRICE_INFO_SEARCH_SESSION_INFO_SAVE,
    search_session_info,
  };
};

export const savePriceInfoSearchData = (search_data) => {
  return { type: TOUR_SEARCH_DATA_SAVE, search_data };
};

export const getAddOnPrice =
  ({
    reference,
    date,
    adults,
    adult_ages,
    children,
    children_ages,
    history,
    rooms = [],
    available_rooms = [],
    source_entity,
    market_type,
  }) =>
  async (dispatch, getState) => {
    // const state = getState();

    const payload = {
      market_type,
      reference,
      date,
      adults,
      adult_ages,
      children,
      children_ages,
      source_entity,
      rooms,
    };
    const result = await fetchAddOnPrice(payload);

    const msg =
      "We couldn't find a price for this date. Please try again for a different date.";

    if (result) {
      await dispatch(savePriceInfo({ ...result }));
      await dispatch(savePriceInfoSearchData({ ...payload, available_rooms }));
      const session_result = await storeSearchSessionMetadata({
        service_type: "MI",
        session_data: getState().TourPriceInfo,
      });
      if (!session_result) {
        toast.warning(msg, { duration: 5000 });
        return;
      }
      const { session_id: page_session_id } = session_result;
      dispatch(savePriceInfoSearchSessionInfo({ page_session_id }));
      history.push(`/tour/booking_process/${page_session_id}`);
    } else {
      toast.warning(msg, { duration: 5000 });
    }
  };
